import { MenuItem, Select, Stack, SxProps, Typography } from "@mui/material";
import { ReactNode } from "react";

interface IMuiSelect {
  name?: string;
  label?: string;
  placeholder?: string;
  value: string;
  handleChange: any;
  disabled?: boolean;
  width?: any;
  error?: null | boolean | ReactNode;
  Example?: string;
  sxStyle?:SxProps ;
  required?: boolean;
  options: { value: string; label: string }[];
}

export default function MuiSelect({
  handleChange,
  label,
  name,
  disabled,
  placeholder,
  value,
  width = "100%",
  required,
  options,
  sxStyle,
}: Readonly<IMuiSelect>) {
  return (
    <Stack width={width}>
      {label && (
        <Typography
          sx={{
            fontWeight: "500",
            fontSize: "11.24px",
            lineHeight: "21.36px",
            mb: "4px",
          }}
        >
          {label}
        </Typography>
      )}
      <Select
        disabled={disabled}
        name={name}
        required={required}
        defaultValue={options[0].value}
        placeholder={placeholder}
        onChange={handleChange}
        value={value}
        sx={{
          "& .MuiSelect-select": {
            py: "8px",
            px: "12px",
          },
          "& fieldset": {
            border: "1px solid var(--gray-400)",
            borderColor: (theme) => theme.palette.gray[400],
            borderWidth: "1px",
            borderStyle: "solid",
          },
          ...sxStyle,
        }}
      >
        {options.length > 0 &&
          options.map(({ label, value }) => (
            <MenuItem key={value} value={value}>
              {label}
            </MenuItem>
          ))}
      </Select>
    </Stack>
  );
}
